import { Injectable } from '@angular/core';
import { SimpleEntityDataEditorService } from '../../../../../shared/services/searchable-entity/simple-entity/simple-entity-data-editor.service';
import { CoreServiceRegistry } from '../../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../../shared/shared-service-registry';
import { SimpleEntityDataService } from '../../../../../shared/services/searchable-entity/simple-entity/simple-entity-data.service';
import { SearchCriteria, Clause } from '../../../../../shared/search/models/search-filter-model';

@Injectable()
export class ViewReportDataEditorService extends SimpleEntityDataEditorService {

  protected dataService: SimpleEntityDataService;

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
      protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }

  protected createDefaultSearchCriteria(currentRow: any, selectedColumnValue: any, property: any) {
    const defaultSearchCriteria = new SearchCriteria();
    defaultSearchCriteria.conditions = [];
    defaultSearchCriteria.loadDefaultCriteria = false;
    const defaultCondition = this.createSearchCondition(1);
    defaultCondition.isReadOnly = true;
    defaultCondition.isMandatory = true;
    const defaultClause = new Clause();
    defaultClause.operation = '=';
    if (property === 'storerKey' || property === 'storerName') {
      defaultClause.column = 'storerType';
      defaultClause.value = '1';
    }
    defaultClause.operation = '=';
    defaultCondition.clauses = [defaultClause];
    defaultCondition.operator = 'AND';
    defaultSearchCriteria.conditions.push(defaultCondition);
    return defaultSearchCriteria;
  }

  protected getLookupModalTitle(property: string) {
    switch (property) {
      case 'storerKey': return this.resourceService.get('storer_Id');
      default: return property;
    }
  }
 //[LFWM-1984][Lookup screens search accordion][Added function to map subtitle in lookup component]
  protected getLookupModalSubTitle(property: string) {
    switch (property) {
      case 'storerKey': return this.resourceService.get('storer_Id').concat(' ').concat(this.resourceService.get('lbl_search'));
      default: return property;
    }
  }

  protected getDependantMapForProperty(property: string) {
    let propMap: any;
    if (property === 'storerKey') {
      propMap = {
        'storerKey': 'storerName'
      };
    } else {
      propMap = {};
    }
    return propMap;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/control/inventory/view-report/services/viewreport-data-editor.service.ts